const footer = {
  listStyle: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '12px 15px 12px 20px',
  padding: 0,
}

const galleryContainer = {
  width: '374px',
  minHeight: '187px',
  maxHeight: '375px',
  overflow: 'hidden',
}

const previewWrapper = {
  paddingBottom: '12px',
}

const singleAsset = {
  width: '375px',
  border: '1px solid white',
}

const styles = {
  footer,
  galleryContainer,
  previewWrapper,
  singleAsset,
}

export { styles }
